import React from 'react';

interface Props {
    index: number;
    title: string;
    desc?: string;
    time: string;
    isLast: boolean;
}

const TimelineItem = ({ index, title, desc, time, isLast }: Props) => {
    return (
        <div className="flex flex-row mx-2 gap-4" style={{ minHeight: '45px' }}>
            <div className="flex flex-col items-center">
                <div className="font-bold rounded-full bg-grey-200 border-grey-500 border-2 w-6 h-6 text-center">{index}</div>
                {!isLast && <div className="w-0.5 h-full bg-grey-500" />}
            </div>
            <div className="flex-grow mb-4">
                <div className="flex flex-row justify-between gap-8 ">
                    <div className="font-bold">{title}</div>
                    <div className="flex self-end min-w-max italic text-xs">{time}</div>
                </div>
                {desc && <div className="text-xs">{desc}</div>}
            </div>
        </div>
    );
};

export default TimelineItem;
